import { Id, TextField } from "@dgs/core";
import { TFunction } from "i18next";
import { ReactNode } from "react";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";
import { TwoColumn } from "./RelationListSection";

interface PrimaryCompanyValue {
	id: Id;
	company: string;
	position: string | null;
	isPrimary: boolean;
}

export function createPrimaryCompanyContactAttributeBaseHandler(id: Id): IContactAttributeBaseHandler {
	return {
		type: "PRIMARY_COMPANY",
		id,
		getLabel: (t) => t("Company"),
	};
}

export function createPrimaryCompanyContactAttributeProfileHandler(
	id: Id,
	value: PrimaryCompanyValue | null,
): IContactAttributeHandler<PrimaryCompanyValue | null> {
	const baseHandler = createPrimaryCompanyContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value?.company ?? "";
		},
		renderFormField(t: TFunction, prefix): ReactNode {
			return (
				<TwoColumn>
					<TextField name={`${prefix ? `${prefix}.` : ""}${id}.value.company`} label={baseHandler.getLabel(t)} />
					<TextField name={`${prefix ? `${prefix}.` : ""}${id}.value.position`} label={t("Position")} />
				</TwoColumn>
			);
		},
		toRequestValue(): ContactAttributeRequest<PrimaryCompanyValue | null> {
			return { id, value: this.value?.company === null ? null : this.value };
		},
	};
}

export function createPrimaryCompanyContactAttributeListHandler(id: Id): IContactAttributeListHandler {
	const baseHandler = createPrimaryCompanyContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
